"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.productPropertiesLayoutRenderer = productPropertiesLayoutRenderer;
const React = __importStar(require("react"));
const Contexts = __importStar(require("../contexts"));
const genesys_properties_selector_helpers_1 = require("../genesys-properties-selector-helpers");
const group_renderer_1 = require("./group-renderer");
function productPropertiesLayoutRenderer(props) {
    const selectorInfoMap = (0, genesys_properties_selector_helpers_1.createSelectorInfoMap)(props.selectors);
    return (React.createElement(Contexts.propertiesSelectorContext.Consumer, null, ({ activatedQuantitySelectors, conversionParametersMap, filterPrettyPrint, groupFilter, showGroups, onQuantityChange, layoutRendererExtraProps, translatePropertyValue, valueSources }) => {
        if (layoutRendererExtraProps.sections.length === 0) {
            return React.createElement("div", null);
        }
        const groups = (groupFilter.size > 0
            ? layoutRendererExtraProps.sections[0].groups.filter(g => groupFilter.has(g.key))
            : layoutRendererExtraProps.sections[0].groups).map(group => (React.createElement(group_renderer_1.GroupRenderer, { key: `${layoutRendererExtraProps.uniqueId}-${group.key}`, filterPrettyPrint: filterPrettyPrint, renderGroup: group, showGroups: showGroups, fieldGroup: layoutRendererExtraProps.fieldGroup, hidePropertyNames: layoutRendererExtraProps.hidePropertyNames, rowRendererType: {
                type: "ProductPropertyRowRenderer",
                propertyFormats: layoutRendererExtraProps.propertyFormats,
                valueSourcesDict: valueSources || {},
                translatePropertyValue: translatePropertyValue
            }, selectorInfoMap: selectorInfoMap, activatedQuantitySelectors: activatedQuantitySelectors, onQuantityChange: onQuantityChange, conversionParametersMap: conversionParametersMap })));
        return React.createElement("div", null, groups);
    }));
}
//# sourceMappingURL=product-properties-layout-renderer.js.map